import React, { useState } from 'react';
import closeIcon from '../../../../assets/img/circle-close.svg';
import lockIcon from '../../../../assets/img/Lock Icon.png';
import infoIcon from '../../../../assets/img/Info Icon.png';
import bookmarkIcon from '../../../../assets/img/White Bookmark Icon.png';
import checkmarkIcon from '../../../../assets/img/White Checkmark Icon.png';
import { modalOpen } from '../../../../helpers';

const LockedCategoryModal = ({ category, isInterested, onInterest, onClose }) => {
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    modalOpen(false);
    onClose();
  };

  const handleInterest = () => {
    setLoading(true);
    onInterest(category.id)
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  return (
    <div className="locked-module-overlay" onClick={handleClose}>
      <div className="locked-module-modal" onClick={(e) => e.stopPropagation()}>
        <img className="locked-module-close" src={closeIcon} alt="Close" onClick={handleClose} />
        <img src={lockIcon} alt="" className="locked-module-icon" />
        <h2 className="locked-module-title">This module isn&apos;t included in your firm&apos;s license</h2>
        <hr className="locked-module-divider" />
        <p className="locked-module-body">
          Your firm&apos;s current TRAINER license does not include access to this module.
        </p>
        <div className="locked-module-info-row">
          <img src={infoIcon} alt="" className="locked-module-info-icon" />
          <span>Interested in this content? Click the bookmark icon below to indicate interest in future access.</span>
        </div>
        <button
          className="locked-module-btn"
          style={isInterested ? { backgroundColor: '#98c678' } : {}}
          onClick={handleInterest}
          disabled={loading}
        >
          <img src={isInterested ? checkmarkIcon : bookmarkIcon} alt="" className="locked-module-btn-icon" />
          {loading ? 'Saving...' : isInterested ? 'Interest Recorded' : 'Keep Me Posted'}
        </button>
      </div>
    </div>
  );
};

export default LockedCategoryModal;
